import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://seller.udyamwell.in/api'; // Replace with your actual API URL
const API_URL_ = process.env.REACT_APP_API_URL || 'https://seller.udyamwell.in';

export const fetchProfile = async (id: any) => {
  const response = await axios.get(`${API_URL}/user/${id}`);
  return response.data;
};

export const updateProfile = async (profileData: any) => {
  const response = await axios.put(`${API_URL}/user/update`, profileData);
  return response.data;
};

export const fetchUserProducts = async (data: any) => {
  const response = await axios.post(`${API_URL}/product-list`, data);
  return response.data;
};

export const getSubCategory = async (data: any) => {
  const response = await axios.post(`${API_URL}/product/subcategory`, data);
  return response.data.data;
};

export const getProductDetailsById = async (id: any) => {
  const response = await axios.get(`${API_URL}/product/${id}`);
  return response.data;
};


export const fetchUserOrders = async (data: any) => {
  const response = await axios.get(`${API_URL}/order-list-web`, data);
  return response.data;
};

export const getOrderDetailsById = async (id: any) => {
  const response = await axios.get(`${API_URL}/order/${id}`);
  return response.data;
};

export const getLabelZip = async (items: any) => {
  const res = await axios.post(
    `${API_URL}/order/download-labels-zip/by-id`,
    { items },
    { responseType: "blob" } // 👈 tells Axios to return binary data, not JSON
  );
  return res;
};


export const fetchDashboardDetail = async (id: any) => {
  const response = await axios.get(`${API_URL}/dashboard/stats?userId=${id}`);
  return response.data;
};

// --- ENTERPRISE APIs ---

export const fetchSellers = async (organisationId: string, page: number = 1, district: string = '', category: string = '', search: string = '', limit: number = 10) => {
  const response = await axios.get(`${API_URL}/org/sellers?organisationId=${organisationId}&page=${page}&limit=${limit}&district=${encodeURIComponent(district)}&category=${encodeURIComponent(category)}&search=${encodeURIComponent(search)}`);
  return response.data;
};

export const createSeller = async (data: any) => {
  const response = await axios.post(`${API_URL}/org/sellers`, data);
  return response.data;
};

export const sendAIChat = async (message: string, userId: string) => {
  const response = await axios.post(`${API_URL}/ai/chat`, { message, userId });
  return response.data;
};

export const fetchAIInsights = async (metrics: any) => {
  const response = await axios.post(`${API_URL}/ai/insights`, { metrics });
  return response.data;
};

export const fetchCampaigns = async (userId: string) => {
  const response = await axios.get(`${API_URL}/campaigns?userId=${userId}`);
  return response.data;
};

export const createCampaign = async (data: any) => {
  const response = await axios.post(`${API_URL}/campaigns`, data);
  return response.data;
};


export const uploadImage = async (data: any) => {
  const response = await axios.post(`${API_URL}/upload`, data);
  return response.data;
};

export const updateOrderStatus = async (orderId: string, status: string) => {
  const response = await axios.put(`${API_URL}/order-update`, { orderId, status });
  return response.data;
};

export const importProductsApi = async (file: File, category: string, sellerId?: string) => {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('category', category);
  if (sellerId) {
    formData.append('sellerId', sellerId);
  }

  const token = localStorage.getItem('authToken');
  const headers: Record<string, string> = {};
  if (token) {
    headers['authorization'] = `Bearer ${token}`;
    headers['token'] = token;
  }

  const response = await axios.post(`${API_URL}/product/import`, formData, { headers });
  return response.data;
};

export const deleteProductApi = async (productId: string) => {
  const token = localStorage.getItem('authToken');
  const headers: Record<string, string> = {};
  if (token) {
    headers['authorization'] = `Bearer ${token}`;
    headers['token'] = token;
  }

  const response = await axios.delete(`${API_URL}/product-delete`, {
    data: { productId, id: productId },
    params: { productId, id: productId },
    headers,
  });
  return response.data;
};

// --- ONDC IGM (Issue & Grievance Management) ---
export const fetchAllIssues = async (
  userId: string = '6a180e5debe41f7e14571243',
  page: number = 1,
  limit: number = 10
) => {
  const params: Record<string, string> = {
    page: page.toString(),
    limit: limit.toString(),
  };
  if (userId) {
    params.userId = userId;
  }
  const response = await axios.get(`${API_URL_}/igm/all-issue`, { params });
  return response.data;
};

export interface IssueResponsePayload {
  transaction_id: string;
  respondent_action?: 'PROCESSING' | 'RESOLVED' | 'CASCADED' | string;
  action_triggered?: 'NO-ACTION' | 'REFUND' | 'REPLACEMENT' | 'CANCEL' | string;
  short_desc: string;
  long_desc: string;
  refund_amount?: number | string;
}

export const respondToIssue = async (data: IssueResponsePayload) => {
  const response = await axios.post(`${API_URL_}/igm/issue_response`, data);
  return response.data;
};



